import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "../../assets/css/Footer.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Footer() {
  const navigate = useNavigate();
  const [allSection, setAllSection] = useState({});
  const [searchDatabase, setSearchDatabase] = useState("");

  useEffect(() => {
    let active = true;

    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}footer-counts`);

        if (active) {
          setAllSection(response.data || {});
        }
      } catch (error) {
        console.error("Error loading footer counts:", error);
      }
    };

    fetchData();

    return () => {
      active = false;
    };
  }, []);

  const handleSearch = (event) => {
    event.preventDefault();

    const searchTerm = searchDatabase.trim();

    if (!searchTerm) return;

    navigate(`/searches/${encodeURIComponent(searchTerm)}`);
  };

  const agencies = [
    ["Federal Housing Authority", "https://fha.gov.ng"],
    ["Federal Mortgage Bank of Nigeria", "https://www.fmbn.gov.ng"],
    ["Surveyors Registration Council of Nigeria", "https://surcon.gov.ng"],
    ["Office of the Surveyor General of the Federation", "http://osgof.gov.ng"],
    [
      "Architects Registration Council of Nigeria",
      "https://www.arconigeria.gov.ng",
    ],
    ["Council of Registered Builders of Nigeria", "https://www.corbon.gov.ng/"],
    [
      "Quantity Surveying Registration Board of Nigeria",
      "https://qsrbn.gov.ng",
    ],
    ["Town Planners Registration Council of Nigeria", "https://toprecng.org"],
    [
      "Nigerian Institution of Estate Surveyors and Valuers",
      "https://www.niesv.org.ng",
    ],
    [
      "Estate Surveyors and Valuers Registration Board of Nigeria",
      "https://www.esvarbon.gov.ng",
    ],
  ];

  const pages = [
    {
      name: "Legal Disclaimer & Privacy Policy",
      url: "/Legal Disclaimer and Privacy Policy/15",
    },
    { name: "Frequently Asked Questions", url: "/F.A.Q/38" },
    { name: "Disclaimer", url: "/Disclaimer/18" },
    {
      name: "Official Webmail",
      url: "https://webmail.fmw.gov.ng",
      external: true,
    },
  ];

  const categories = [
    {
      name: "Latest Press",
      url: "/read/title_show_echo_01zz",
      count: allSection.latest_news,
    },
    {
      name: "Public Announcements",
      url: "/read/title_show_echo_01",
      count: allSection.public_announcement,
    },
    {
      name: "Other News",
      url: "/read/title_show_echo_02",
      count: allSection.other_news,
    },
    {
      name: "Speeches",
      url: "/read/title_show_echo_03",
      count: allSection.speeches,
    },
  ];

  const socialLinks = [
    {
      name: "X",
      icon: "fa-brands fa-x-twitter",
      url: "https://x.com/FMWNIG",
    },
    {
      name: "Facebook",
      icon: "fa-brands fa-facebook-f",
      url: "https://www.facebook.com/FMWNG",
    },
    {
      name: "LinkedIn",
      icon: "fa-brands fa-linkedin-in",
      url: "https://www.linkedin.com/in/FMWNG",
    },
    {
      name: "Instagram",
      icon: "fa-brands fa-instagram",
      url: "https://www.instagram.com/fmwng",
    },
    {
      name: "YouTube",
      icon: "fa-brands fa-youtube",
      url: "https://www.youtube.com/channel/UCu9KmHLhSyhPItgK6yGo45Q",
    },
  ];

  return (
    <footer className="fmw-footer">
      {/* Archive search banner */}
      <section className="fmw-footer-search">
        <div className="container">
          <div className="fmw-footer-search-inner">
            <div className="fmw-footer-search-copy">
              <span className="fmw-footer-eyebrow">
                MINISTRY INFORMATION CENTRE
              </span>
              <h2>Find the information you need.</h2>
              <p>
                Explore archived news, public announcements, speeches and
                ministry information.
              </p>
            </div>

            <form
              className="fmw-footer-search-form"
              onSubmit={handleSearch}
              role="search"
            >
              <label
                htmlFor="fmw-footer-search-input"
                className="fmw-footer-visually-hidden"
              >
                Search ministry archives
              </label>

              <input
                id="fmw-footer-search-input"
                type="search"
                value={searchDatabase}
                onChange={(event) => setSearchDatabase(event.target.value)}
                placeholder="Enter a search keyword..."
                required
              />

              <button type="submit">
                <i
                  className="fa-solid fa-magnifying-glass"
                  aria-hidden="true"
                />
                <span>Search</span>
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Main footer content */}
      <div className="fmw-footer-main">
        <div className="container">
          <div className="row g-5">
            {/* Contact and social media */}
            <div className="col-lg-4 col-md-6">
              <section className="fmw-footer-column">
                <h3 className="fmw-footer-heading">Contact the Ministry</h3>
                <span className="fmw-footer-heading-line" />

                <p className="fmw-footer-ministry-name">
                  Federal Ministry of Works
                </p>

                <div className="fmw-footer-contact">
                  <span className="fmw-footer-contact-icon">
                    <i
                      className="fa-solid fa-location-dot"
                      aria-hidden="true"
                    />
                  </span>
                  <div>
                    <strong>Headquarters</strong>
                    <p>Mabushi, Abuja, Nigeria</p>
                  </div>
                </div>

                <div className="fmw-footer-contact">
                  <span className="fmw-footer-contact-icon">
                    <i className="fa-regular fa-envelope" aria-hidden="true" />
                  </span>
                  <div>
                    <strong>Email Addresses</strong>
                    <a href="mailto:info@fmw.gov.ng">info@fmw.gov.ng</a>
                    <a href="mailto:registryhm@fmw.gov.ng">
                      registryhm@fmw.gov.ng
                    </a>
                    <a href="mailto:registryhms@fmw.gov.ng">
                      registryhms@fmw.gov.ng
                    </a>
                    <a href="mailto:registryops@fmw.gov.ng">
                      registryops@fmw.gov.ng
                    </a>
                    <a href="mailto:registryfmw@fmw.gov.ng">
                      registryfmw@fmw.gov.ng
                    </a>
                  </div>
                </div>

                <div className="fmw-footer-contact">
                  <span className="fmw-footer-contact-icon">
                    <i className="fa-solid fa-phone" aria-hidden="true" />
                  </span>
                  <div>
                    <strong>Telephone</strong>
                    <a href="tel:+2349122058161">+234 9 122 0581 61</a>
                    <p className="fmw-footer-small-text">
                      Monday – Friday, 8:00 a.m. – 4:00 p.m.
                    </p>
                  </div>
                </div>

                <div className="fmw-footer-social">
                  <h4>Follow Us On</h4>
                  <div className="fmw-footer-social-links">
                    {socialLinks.map((social) => (
                      <a
                        key={social.name}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Visit FMW on ${social.name}`}
                        title={social.name}
                      >
                        <i className={social.icon} aria-hidden="true" />
                      </a>
                    ))}
                  </div>
                </div>
              </section>
            </div>

            {/* Agencies and useful pages */}
            <div className="col-lg-4 col-md-6">
              <section className="fmw-footer-column">
                <h3 className="fmw-footer-heading">Other Agencies</h3>
                <span className="fmw-footer-heading-line" />

                <ul className="fmw-footer-links">
                  {agencies.map(([name, url]) => (
                    <li key={name}>
                      <i
                        className="fa-solid fa-angle-right"
                        aria-hidden="true"
                      />
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        {name}
                      </a>
                    </li>
                  ))}
                </ul>
              </section>

              <section className="fmw-footer-column fmw-footer-secondary">
                <h3 className="fmw-footer-heading">Useful Information</h3>
                <span className="fmw-footer-heading-line" />

                <ul className="fmw-footer-links">
                  {pages.map((page) => (
                    <li key={page.name}>
                      <i
                        className="fa-solid fa-angle-right"
                        aria-hidden="true"
                      />
                      {page.external ? (
                        <a
                          href={page.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {page.name}
                        </a>
                      ) : (
                        <Link to={page.url}>{page.name}</Link>
                      )}
                    </li>
                  ))}
                </ul>
              </section>
            </div>

            {/* Categories and location */}
            <div className="col-lg-4 col-md-12">
              <section className="fmw-footer-column">
                <h3 className="fmw-footer-heading">News & Updates</h3>
                <span className="fmw-footer-heading-line" />

                <ul className="fmw-footer-categories">
                  {categories.map((category) => (
                    <li key={category.name}>
                      <Link to={category.url}>
                        <span>{category.name}</span>
                        <span className="fmw-footer-count">
                          {category.count ?? 0}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </section>

              <section className="fmw-footer-column fmw-footer-map-section">
                <h3 className="fmw-footer-heading">Our Location</h3>
                <span className="fmw-footer-heading-line" />

                <div className="fmw-footer-map">
                  <iframe
                    title="Federal Ministry of Works location"
                    src="https://www.google.com/maps?q=Federal%20Ministry%20of%20Works%2C%20Mabushi%2C%20Abuja&output=embed"
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>

                <p className="fmw-footer-map-caption">
                  Federal Ministry of Works, Mabushi, Abuja, Nigeria.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright and credit */}
      <div className="fmw-footer-bottom">
        <div className="container fmw-footer-bottom-inner">
          <p>
            © {new Date().getFullYear()}{" "}
            <strong>Federal Ministry of Works</strong>. All Rights Reserved.
          </p>

          <p className="fmw-footer-credit">
            Designed by{" "}
            <a
              href="https://cviewsoft.com.ng"
              target="_blank"
              rel="noopener noreferrer"
            >
              CViewSoft Ltd
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
